import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { SubscriptionCatalogService } from 'src/app/services/subscription-catalog.service';
import { TranslationService } from 'src/app/services/translation.service';
@Component({
  selector: 'plans-and-pricing',
  standalone: true,
  templateUrl: './plans-and-pricing.component.html',
  styleUrl: './plans-and-pricing.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule]
})
export class PlansAndPricingComponent implements OnInit {
  translationLabels: any;
  constructedProducts: any = [];
  allProducts: any;
  products: any = [];
  isSession: boolean = false;

  constructor(private translationService: TranslationService,
    private cdr: ChangeDetectorRef,
    private subscriptionCatalogService: SubscriptionCatalogService,
    private configService: ConfigService,
    private _router: Router,
    private authService: AuthService
  ) { 
      this.isSession = this.authService.loggedInStatus
    }

  ngOnInit() {
    this.translationLabels = this.translationService.getTranslationForPage('plans_and_planning');
    this.allProducts = this.subscriptionCatalogService.getProductCatalog();
    let pricingCompareProductCode = this.configService.getBackOfficeConfig().PRICING_COMPARE_PRODUCT_CODE;
    this.products = pricingCompareProductCode.map(productCode => this.allProducts.find((product: any) => product.productCodeC == productCode)).filter(product => product != undefined);
    // console.log('Products: ', this.products)
    this.products.forEach((product: any) => {
      let plans = product.ratePlans.map((item: any) => ({
        label: '$' + item.netprice + '/' + item.labelDuration + '*',
        value: item.labelDuration
      }));
      let obj = {
        title: product.header,
        description: product.messageheader,
        ratePlansOptions: plans,
        selectedOption: plans[0]
      }
      this.constructedProducts.push(obj);
    });
    this.cdr.markForCheck();
  }

  navigateToProduct() {
    this._router.navigateByUrl('../products', {
    })
  }
}